/**
 * 终端类型
 */
export enum TerminalType {
  Mobile = 1,
  PC = 2,
}

export enum REACT_APP_ENV_MAP {
  local = 'local',
  test = 'test',
  staging = 'staging',
  production = 'production',
}

export const DOMAIN_MAP: Record<string, string> = {
  [REACT_APP_ENV_MAP.local]: 'http://mtdx.cap.test.sankuai.com', // 'https://hz.cap.test.sankuai.com',
  [REACT_APP_ENV_MAP.test]: 'http://mtdx.cap.test.sankuai.com', // 'https://hz.cap.test.sankuai.com',
  [REACT_APP_ENV_MAP.staging]: 'https://mtdx.cap.st.meituan.com/', // 'https://123.cap.st.meituan.com',
  [REACT_APP_ENV_MAP.production]: 'https://daxue.meituan.com',
};

const ssrApiHost = process.env.REACT_APP_SSR_API_HOST;

export const SSR_API_HOST: Record<string, string> = {
  [REACT_APP_ENV_MAP.local]: ssrApiHost || DOMAIN_MAP[REACT_APP_ENV_MAP.test],
  [REACT_APP_ENV_MAP.test]: ssrApiHost || DOMAIN_MAP[REACT_APP_ENV_MAP.test],
  [REACT_APP_ENV_MAP.staging]: ssrApiHost || DOMAIN_MAP[REACT_APP_ENV_MAP.staging],
  [REACT_APP_ENV_MAP.production]: DOMAIN_MAP[REACT_APP_ENV_MAP.production],
};

/** 小程序名称映射 */
export const CLIENT_NAME_MAP = {
  /**
   * @deprecated
   * 创业版微信小程序
   */
  CYB: 'cyb',

  /**
   * @deprecated
   * 创业版美团小程序
   */
  CYB_MT: 'cyb_mt',
  /**
   * 美团创业版h5，包括开店指南付费课简介页
   */
  CYB_H5: 'cyb_h5',
};
